import React from 'react';
import {COLORS} from '@fupa/fupa-uikit';
import styled from 'styled-components';
import {AppBar} from 'app/components/appBar';
import {Footer} from 'app/components/Footer';
import {TopElevenForm} from 'app/components/admin/TopElevenForm';
import {SubstitutesForm} from 'app/components/admin/SubstitutesForm';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${COLORS.lightGrey};
  width: 100%;
`;

const FormContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  max-width: 62.5rem;
`;

const Admin = () => {
  return (
    <React.Fragment>
      <AppBar />
      <Content>
        <FormContainer>
          <TopElevenForm id='1' header='Erste Elf' />
          <TopElevenForm id='2' header='Zweite Elf' />
        </FormContainer>
        <SubstitutesForm id='3' />
      </Content>
      <Footer />
    </React.Fragment>
  );
};

export {Admin};
